export type WordPressExchangeRoute = 'register-if-new' | 'sign-in-only' | 'deny';

/** Only explicit, trusted server responses may enter a legacy path. */
export function wordpressExchangeRoute(status: number | undefined, code: unknown): WordPressExchangeRoute {
  if (status === 404 && code === 'NO_LINKED_ACCOUNT') return 'register-if-new';
  if (status === 409 && code === 'INCOMPLETE_WORDPRESS_SIGNUP') return 'sign-in-only';
  if (status === 403 && code === 'NO_ACTIVE_MEMBERSHIP') return 'sign-in-only';
  return 'deny';
}

/** Existing identities must never fall through to signUp after a failed password. */
export function enforceLegacySignInResult<T extends { error: unknown }>(result: T, signInOnly: boolean): T {
  if (signInOnly && result.error) throw result.error;
  return result;
}
